import React from 'react'
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom'
import { ThemeProvider, CssBaseline, StyledEngineProvider, Box } from '@mui/material'
import theme from './theme'
import AppHeader from './components/AppHeader'
import AppFooter from './components/AppFooter'
import CatalogPage from './pages/CatalogPage'
import DetailPage from './pages/DetailPage'

// Every catalog page shares one chrome layout — an EdPro-branded header and
// matching footer that mirror edpro.ua so visitors don't feel like they left.
// The URL hierarchy is:
//   /                                  all resources
//   /:product                          one product
//   /:product/:model                   one model
//   /:product/:model/:version          one version
// (/:product/:model/:version/:filename is a direct download, served by Rails.)
function Layout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppHeader />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <AppFooter />
    </Box>
  )
}

// injectFirst makes MUI emit its styles before Tailwind's, so Tailwind utility
// classes can still override component styling when needed.
export default function App({ basename }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter basename={basename}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<CatalogPage />} />
              <Route path="/:productSlug" element={<DetailPage scope="product" />} />
              <Route path="/:productSlug/:modelSlug" element={<DetailPage scope="model" />} />
              <Route
                path="/:productSlug/:modelSlug/:versionSlug"
                element={<DetailPage scope="version" />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
